class LoginController {
  constructor ($log, $timeout, AuthService) {
    'ngInject'

    this._$log = $log
    this._$timeout = $timeout
    this._AuthService = AuthService
  }

  $onInit () {
    this.working = false
    this.error = ''
  }

  signIn () {
    this._$log.log('loginController [signIn]: Redirecting to Azure B2C...')

    this.working = true
    this.error = ''

    this._AuthService.loginRedirect()
      .catch(error => {
        this._$log.error('loginController: [signIn]: Error', error)
        this.error = error && error.message ? error.message : 'Login failed.'
      })
      .finally(() => {
        this._$timeout(() => {
          this.working = false
        }, 2000)
      })
  }
}

export default {
  controller: LoginController,
  template: require('./login.component.html').default
}
